/**
 * Academy domain — `AcademyBrandingStore` state shape. Remote-only, in-memory.
 * `hostBranding` holds the anonymous host branding; `tenantBrandingById` backs the
 * authenticated tenant-branding CRUD list.
 */
import type { Guid } from './academy-enums.model';
import type { BrandingResponse } from './academy-responses.model';
import type { TenantBrandingResponse } from './academy.model';

export interface AcademyBrandingState {
  /** White-label branding for the calling host (anonymous `GET /branding`). */
  hostBranding: BrandingResponse | null;
  /** Order of the last tenant-branding `list` result. */
  tenantBrandingIds: Guid[];
  /** Tenant brandings by id. */
  tenantBrandingById: Record<Guid, TenantBrandingResponse>;
}

export const initialAcademyBrandingState: AcademyBrandingState = {
  hostBranding: null,
  tenantBrandingIds: [],
  tenantBrandingById: {},
};
